<template>
  <!-- Error page-->
  <div class="misc-wrapper">
      <span class="brand-logo">
        <b-img
          v-if="dark != true"
          :src="appLogoImage"
          alt="logo"
          width="200px"
        />
        <b-img v-else :src="appLogoImageDark" alt="logo" width="200px" />
      </span>

    <div class="misc-inner p-2 p-sm-3">
      <div class="w-100 text-center">
        <h2 class="mb-1">Página não encontrada 🕵🏻‍♀️</h2>
        <p class="mb-2">
          Oops! 😖 Essa página não foi encontrada nesse servidor.
        </p>

        <b-button
          variant="primary"
          class="mb-2 btn-sm-block"
          :to="{ path: '/' }"
        >
          Voltar para a tela inicial
        </b-button>

        <!-- image -->
        <b-img fluid :src="imgUrl" alt="Error page" />
      </div>
    </div>
  </div>
  <!-- / Error page-->
</template>

<script>
/* eslint-disable global-require */
import { BLink, BButton, BImg } from 'bootstrap-vue';
import VuexyLogo from '@core/layouts/components/Logo.vue';
import store from '@/store/index';
import { $themeConfig } from '@themeConfig';


export default {
  components: {
    VuexyLogo,
    BLink,
    BButton,
    BImg,
  },
  setup() {
    // App Name
    const { appName, appLogoImage, appLogoImageDark } = $themeConfig.app;
    return {
      appName,
      appLogoImage,
      appLogoImageDark,
    };
  },
  data() {
    return {
      downImg: require('@/assets/images/pages/error.svg'),
    };
  },
  computed: {
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.downImg = require('@/assets/images/pages/error-dark.svg');
        return this.downImg;
      }
      return this.downImg;
    },
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-misc.scss';
</style>
